import { Model } from '../model';

export class Country extends Model {
    public id: number;    
    public name: Object;
    public home: boolean;
    public shipping: number; // фиксированная стоимость доставки
    public free: number; // если нет фиксированной цены, то указывается, начиная с какой суммы возможна бесплатная доставка
}
